import createLoader from '@signal/utils/createLoader';
import { syncActiveAccountLoader } from '../user';
/**
 * All other loaders define this loader as a dependency.
 */

export var rootLoader = createLoader('rootLoader', {
  dependencies: [syncActiveAccountLoader]
});